var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._m(0),
      _c(
        "el-row",
        { staticStyle: { "margin-top": "10px" } },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "acl",
                  rawName: "v-acl",
                  value: _vm.RMC_PROT_MEDUSAGE_ITEM_UPDATE,
                  expression: "RMC_PROT_MEDUSAGE_ITEM_UPDATE",
                },
              ],
              staticClass: "btn",
              attrs: { type: "primary" },
              on: { click: _vm.onDownload },
            },
            [_vm._v("导出")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%", "margin-top": "8px" },
          attrs: { data: _vm.tableData, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "farmName", label: "农场名称", width: "100" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "farmBreedingMode",
              label: "养殖模式",
              width: "100",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "cropQty", label: "鸡群数量(只)", width: "100" },
          }),
          _c("el-table-column", {
            attrs: { prop: "avgWeight", label: "鸡群平均体重", width: "120" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "avgWeightUom",
              label: "平均体重单位",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      _vm._s(
                        _vm._f("avgWeightUomFilter")(scope.row.avgWeightUom)
                      )
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "cropWeight",
              label: "麦当劳农场出栏量(重量,kg)",
              width: "160",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "totalNetUsage", label: "原粉量", width: "90" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "antibioticsUsage",
              label: "抗生素用量(mg/kg)(原粉量/出栏总重量)",
              width: "220",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "hpciaAntibioticsUsage",
              label: "HPCIA类抗生素使用量(mg/kg)(HPCIA抗生素原粉量/出栏总重量)",
              width: "360",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "usageIn7Day",
              label: "前7日抗生素使用量",
              width: "150",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "info_box_title" }, [
      _c("p", { staticClass: "line" }),
      _c("p", { staticClass: "info_title" }, [
        _vm._v("农场维度的药品用量明细"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }